// extracted by mini-css-extract-plugin
export default {"discountButton":"src-pages-SalesChannelContentEditor-SalesChannelEditorAppearance-Preview-DiscountButton-css-module__discountButton--KlJbt"};